/**
 * This file specifies action types as variables to avoid typos
 */
export const GET_CARD_COLLECTION = "GET_CARD_COLLECTION";
export const GET_PLAYER_INVENTORY = "GET_PLAYER_INVENTORY";
export const PROCESS_SET_COLLECTION = "PROCESS_SET_COLLECTION";
export const SELECT_COLOR = "SELECT_COLOR";
export const SELECT_RARITY = "SELECT_RARITY";
export const SET_SHOWCARDS = "SET_SHOWCARDS";
export const SELECT_BOOSTER = "SELECT_BOOSTER";
export const SELECT_SET = "SELECT_SET";
export const SET_SEARCH_TERM = "SET_SEARCH_TERM";
export const SET_SEARCH_TYPE = "SET_SEARCH_TYPE";
export const SHOW_CARD_MODAL = "SHOW_CARD_MODAL";
export const SET_CARD_MODAL_CONTENT = "SET_CARD_MODAL_CONTENT";
export const SHOW_HEADER_MODAL = "SHOW_HEADER_MODAL";
export const SET_HEADER_MODAL_CONTENT = "SET_HEADER_MODAL_CONTENT";
export const RESET = "RESET";
export const UPDATE_IMAGE_LIST = "UPDATE_IMAGE_LIST";
export const SELECT_DETAILS_MENU = "SELECT_DETAILS_MENU";
export const ADD_CARD_TO_DECK = "ADD_CARD_TO_DECK";
export const REMOVE_CARD_FROM_DECK = "REMOVE_CARD_FROM_DECK";
export const SET_DECK = "SET_DECK";
export const SELECT_DECK_TYPE = "SELECT_DECK_TYPE";
export const TOGGLE_ADD_BASICS = "TOGGLE_ADD_BASICS";
export const ADD_CARD_TO_SIDEBOARD = "ADD_CARD_TO_SIDEBOARD";
export const REMOVE_CARD_FROM_SIDEBOARD = "REMOVE_CARD_FROM_SIDEBOARD";
export const CHANGE_COMMANDER = "CHANGE_COMMANDER";
export const CHANGE_COMPANION = "CHANGE_COMPANION";
export const SELECT_CARD_TYPES = "SELECT_CARD_TYPES";
export const SET_SIDEBOARD = "SET_SIDEBOARD";
export const SET_ADD_TYPE = "SET_ADD_TYPE";
export const SET_DRAG_CARD = "SET_DRAG_CARD";
export const DROP_CARD = "DROP_CARD";
export const LIMITED_SORT = "LIMITED_SORT";
export const SET_CURRENT_DRAG_OVER = "SET_CURRENT_DRAG_OVER";
export const SELECT_CMCS = "SELECT_CMCS";
export const ADD_CARD_TO_COLLECTION = "ADD_CARD_TO_COLLECTION";
export const REMOVE_CARD_FROM_COLLECTION = "REMOVE_CARD_FROM_COLLECTION";
export const SET_PACK_NUMBER = "SET_PACK_NUMBER";
